import { render, staticRenderFns } from "./RoasByChannel.vue?vue&type=template&id=32197b11&"
import script from "./RoasByChannel.vue?vue&type=script&lang=js&"
export * from "./RoasByChannel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports